export const Experiments = {
  b2c_041_fundraising_page_donation_prompts_2:
    'b2c_041_fundraising_page_donation_prompts_2',
  b2c_036_donate_button_colour: 'b2c_036_donate_button_colour',
  b2c_038_secure_donate_buttons: 'b2c_038_secure_donate_buttons',
  b2c_029_first_to_donate: 'b2c_029_first_to_donate',
  b2c_040_frp_trust_proposition_bar: 'b2c_040_frp_trust_proposition_bar',
};
